export const checkWishList = (wishlistData, sku) => {
    let data = wishlistData && wishlistData?.length > 0 && wishlistData.filter((e) => e?.product?.sku === sku)
    return data?.length > 0 ? true : false
}